import { ComponentPropsWithoutRef, memo } from 'react';

function ArrowUpIconNew(props: ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      width="20"
      height="13"
      viewBox="0 0 20 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.875 10.4609L10 2.33594L18.125 10.4609"
        stroke="#1D1D1D"
        strokeWidth="2.36979"
        strokeLinecap="square"
      />
    </svg>
  );
}

export default memo(ArrowUpIconNew);
